import React from "react";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StoreAdminDetails } from "../../../../types/modules/admin/StoreAdmin.type";

type Props = {
  store: StoreAdminDetails;
};

const Sector: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { sector } = store;

  return (
    <div className="border-t border-LightGrey3 pt-4">
      <h2 className="text-lg font-semibold text-Black mb-2 flex items-center gap-2">
        <Info className="w-5 h-5 text-primary" /> {t("sector")}
      </h2>
      <div className="grid grid-cols-2 gap-4 text-sm text-muted">
        <p>
          <span className="font-medium text-Black">{t("sector")}: </span>
          {sector.languages[0]?.name || "—"}
        </p>
      </div>
    </div>
  );
};

export default Sector;
